//腾讯图片地址链接配置全局挂载
import Vue from 'vue'
export default ({ app }, inject) => {
  inject('myPlugin', Vue.observable({imgOssUrl: 'https://medusa-small-file-1253272780.cos.ap-shanghai.myqcloud.com/static/official/index/' }))
}